<template>
  <div class="count-down-timer">
    <div class="count-down-timer__item-time-item">
      <div class="count-down-timer__item-time" v-if="days > 0">
        {{ TwoDigits(days)}} <br/>
        <label v-if="days > 1">DAYS</label>
        <label v-else>DAY</label>
      </div>
      <div class="count-down-timer__item-time">
        {{ TwoDigits(hours)}} <br/>
        <label v-if="hours > 1">HOURS</label>
        <label v-else>HOUR</label>
      </div>
      <div class="count-down-timer__item-time">
        {{ TwoDigits(minutes) }} <br/> <label>MIN</label>
      </div>
      <div class="count-down-timer__item-time">
        {{ TwoDigits(seconds) }} <br/> <label>SEC</label>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    date: {
      type: String
    }
  },
  data() {
    return {
      now: Math.trunc((new Date()).getTime() / 1000),
      timer: null
    }
  },
  mounted() {
    window.setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000);
    },1000);
  },
  computed: {
    dateInMilliseconds() {
      const date = this.$filters.getDate(this.date);
      const milliSecond = Math.trunc(Date.parse(date) / 1000);
      return milliSecond > 0 ? milliSecond : '00'
    },
    seconds() {
      const seconds = (this.dateInMilliseconds - this.now) % 60
      return seconds > 0 ? seconds : '00';
    },
    minutes() {
      const minutes = Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
      return minutes > 0 ? minutes : '00';
    },
    hours() {
      const hours = Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24
      return hours > 0 ? hours : '00';
    },
    days() {
      const days = Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24)
      return days > 0 ? days : '00';
    }
  },
  methods: {
    TwoDigits(value) {
      if (value < 0) {
        return '00';
      }
      if (value.toString().length <= 1) {
        return `0${value}`;
      }
      return value;
    }
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/home/count-down-timer.scss"/>
